import { DISMISS_NOTIFICATION } from '../../constants'

export const dismissNotification = () => dispatch =>
  dispatch({
    type: DISMISS_NOTIFICATION,
  })
